export default __webpack_public_path__ + "static/media/santa.8db95e50.jpg";